var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-1f76fa84-651c-459f-9b4f-a739bd18dfd5",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-e38c8079-04cd-411d-b9f1-fed91dd62e78 {\n        fill: #f2f2f2;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-c4035044-48ae-4718-be83-9fb99982ac36",
    "data-name": "Group 125-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "uuid-e38c8079-04cd-411d-b9f1-fed91dd62e78",
    d: "M12.02,23.44v-3.31s-.03,0-.05,0c-1.65-.03-2.94-1.37-2.91-2.99-.03-1.31-.03-2.7,0-4.1,0-.84.3-1.57.85-2.12.55-.55,1.28-.85,2.05-.85h0c2.69-.02,5.38-.02,8.07,0h.12c1.61.09,2.85,1.48,2.77,3.09,0,1.24,0,2.53,0,3.83,0,.04,0,.16,0,.29-.03.78-.37,1.52-.95,2.06-.58.54-1.33.82-2.13.79h-.18c-1.24,0-2.48,0-3.72,0h-.11l-3.84,3.32ZM14.02,18.12v.94l1.1-.94h.86c1.24.01,2.48,0,3.71,0h.22c.29.02.54-.08.74-.26.19-.18.3-.42.31-.67,0-.05,0-.09,0-.12,0-1.38,0-2.67,0-3.95.03-.57-.37-1.02-.88-1.04-2.71-.02-5.4-.02-8.08,0h0c-.51,0-.92.41-.92.91v.1c-.02,1.37-.02,2.74,0,4.06-.01.55.4.98.91.99.34,0,1.04,0,1.04,0h1.01Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.9e8e52ae7defc47306ed466d57025ccc.svg";
export { ForwardRef as ReactComponent };